module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAQRJREFUOBHVUrFuwkAMfQ75AJiKEKAbGVNgABbuE/gU/iQd+wud+ATCQhckwsYYCQSMsHUArr6rnKaQoI6tl/fOfvbZloF/b6XsBJ2+HtUaqrXfJuusX3i7r8dPTfVx2CQH8XlCgoEOmIdEmIgvi92e1h4h9A3CoKeVxHxLbDKTJUjcD5CgS8RaoGJVrgP/ivKDlLsQ/5Pqied+4baHrLIjfJlBJDRFckm3mtiNYACu8cNunkCeJvXZBfEwUymxmEd3BYo0bgdnD0dJ/g0ag5PoXIF4HsVn4JlbWkmgEA1mF/O9r/SQ7HHU6soeyFveIe22SVKtq9OF8Bq/R7mHVvjp3w58AriRR7e5kMgOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/Mask Group 127.png
// module id = 1261
// module chunks = 0